//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { CurtainTransitionBasic } from '~/assets/js/transitions.js'

import PostList from '~/components/posts/PostList'
import PostContent from '~/components/posts/PostContent'
import BtnShop from '~/components/layout/BtnShop'
import ShareLink from '~/components/layout/ShareLink'

export default {
    mixins: [ CurtainTransitionBasic ],

    colorMode: 'dark',
	
	components: {
		PostList, PostContent, BtnShop, ShareLink
	},

	mounted(){
		this.$colorMode.preference = 'dark'
	},

	data() {
      return {
      		needBtnShop:  this.$store.state.post.acf ?  this.$store.state.post.acf.product : false,
    	}
	},

    async asyncData({ $axios, store, params, app }) {
    	console.log(app.i18n.locale+' - '+params.slug)
  		const post = await $axios.$get('wp/v2/posts' ,{params: 
  			{slug: params.slug, per_page: 1, lang:app.i18n.locale}
  		})
  		store.commit('CURRENT_POST_UPDATE', post[0])
		store.commit('FILTER_BY_CAT', post[0].cats_infos.slug[0])
    },
    
    head() {
    	const googleapi = [];
    	if(this.needBtnShop){
    		var scriptgoogle = {
				src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyC03E_O4SKdG74EJLOw0lJqnTLWf14nhJE`,
				hid: "map", 
				defer: true,
				once : true,
			}
			googleapi[0] = scriptgoogle
    	}
		return {
			script: googleapi,
		}
	}
}
